module.exports = __webpack_public_path__ + "static/media/cf-logo.f9433729.svg";